module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc#ch05",
      "id": "ch05"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("It’s not as if there’s any shortage of coffee shops within spitting distance of Brooklands Hill, but it had been clear – from the moment Sarah had become one of their number – which establishment had been chosen by the movers and shakers of the morning drop-off brigade. There are two of the well-known chains represented, the same as on almost any major high street, as well as a bakery that does a decent latte, but "), _c('em', [_vm._v("HazBeanz")]), _vm._v(" was always going to be the preferred option. The coffee’s good, "), _c('em', [_vm._v("obviously,")]), _vm._v(" the food gets rave reviews, and the décor is predictably … quirky. Mismatched metal tables and exposed brickwork. It’s friendly, with a nice, funky vibe, but most important of all, it’s an independent, which can’t help but reflect well on its customers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It tells the world that "), _c('em', [_vm._v("they")]), _vm._v(" are independent, that they look beyond brands and are eager to do their bit in supporting local businesses. It says that they make informed choices. Above all, it trumpets the simple fact that they can afford to pay a little bit more, each morning, for their hand-ground espressos and fancy pastries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of it makes any real difference to Sarah, who would be "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v("perfectly content to get her coffee from the local garage or, better yet, free from the supermarket, because she’s got a loyalty card. She prefers builders’ tea anyway and is far happier with a bacon sandwich than a cranberry and macadamia muffin. It’s all a lot of flummery and fuss, she reckons. It’s style over content, same as with a lot of things, but that’s not really the point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She needs to be where they are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometimes, she has to kill a few minutes mooching around the shops, because she doesn’t like to be the first one there, but today she’s pleased to see that Savita, Heather and Caroline are already inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their usual table in the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coffees and cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chit-chat …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waves as she passes the steamy window, then summons up the correct expression before she pushes open the door and steps inside. Happy to see them, but suitably harassed, as they all are, of course. Because the drop-off really is a nightmare, isn’t it? It’s no wonder they all need their overpriced coffees afterwards, a sugary treat and the chance to kick back and relax a little.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The truth is, I’m completely exhausted after getting Jacob ready every day,’ Caroline had told her once. ‘Absolutely wiped out. I need that jolt of bloody caffeine after I’ve got him to school, because I’ve still got a full day’s work ahead of me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yeah, I know what you mean.’ Sarah had nodded sympathetically, then exchanged a knowing look with Heather. ‘Sometimes I go home and get straight back into bed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Caroline had looked as if she wanted to punch her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as Sarah has ordered – a skinny latte and a cinnamon bagel – she sits down at a table for one just across from the others. Sometimes she joins them if she’s feeling brave, but most of the time she prefers a bit of space and some time alone. Heather beckons her over, because she’s nice and she probably needs a break from Caroline, but Sarah shakes her head and "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v("holds up the laptop case she’s brought with her. Heather nods her understanding and Sarah mouths a "), _c('em', [_vm._v("sorry.")]), _vm._v(" There’s work she needs to be pushing on with, they always understand that, and if any one of them walks past or comes across for a chat, she’ll close the laptop before they can get a look at what she’s actually doing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It doesn’t matter very much if they see her close it, because they all know why she keeps what she’s doing private.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So, what is it you do?’ Heather had asked her a couple of weeks earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m a … writer.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Really? That’s amazing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not a very successful one or anything. Just a few short stories, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d love to read one. I’m in a book group actually, so maybe—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No chance.’ Sarah had laughed. ‘I never let anyone I know read my stuff. It’s hard enough showing it to the people who pay me for it, to be honest. Not that there’s many of them. And I write under a pseudonym, so there’s no point looking for anything.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve always thought maybe I could write something,’ Heather had said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So, why don’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, I’m sure it’s a lot harder than people think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s just making things up, really.’ Sarah had stepped away, keen to bring an end to it. ‘I’ve always been good at that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, she opens her laptop and stares at the familiar screensaver, then looks up from the screen as single father David comes through the door. He smiles automatically as he crosses to the counter to order. She smiles back, but actually she’s a little disappointed that Alex hasn’t shown up. He’s not a regular, but he comes in a couple of mornings a week and, had he done so today, she would certainly have been happy to join the larger group towards which he usually gravitates. There’s no future in it, she knows that. He’s a happily married stay-at-home dad, "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v("but still, she reckons there’s definitely a spark and a little flirting doesn’t hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A little … imagining.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She watches David go to join the three women by the window, and it’s only then that she sees the man sitting at the table next to her. Or at least, becomes aware that he’s looking at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was he there when she came in? She can’t be sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leans towards her and says, ‘Now, you’re either writing a hard-hitting literary novel, or …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sorry?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I mean, "), _c('em', [_vm._v("definitely")]), _vm._v(" not chick-lit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Or you’re just messing about on Twitter or something.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugs, trying to keep the panic in check.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiles and takes a sip of coffee. ‘I’m trying to decide, that’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s definitely not a Brooklands Hill parent, she’s sure of that because she knows them all by sight. Always makes a point of it. So, he can’t possibly know the things she’s told them about herself. But she’s equally certain that she doesn’t know him from anywhere else, so how could he know anything at all?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She feels the blood rising to her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She doesn’t like the feeling, never has.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Let me know when you’ve reached a decision,’ she says, turning back to her screen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘OK, I’ll do that,’ he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s somewhere in his mid-forties, she decides, a few years older than she is. He’s got a suit on, a thick pinstripe, but he has an open-neck floral shirt and a baggy flat cap. Smart but casual; trendy, she supposes. A look he’s certainly taken some time over. He’s got a silvery goatee beard and a small stud in one ear. He’s wearing glasses with thick brown frames and, behind them, his eyes are very green.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m struggling, to be honest,’ he says after a minute or so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v("‘Shame,’ she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To be sure, I’d really need you to answer a few questions.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glancing over at the table in the window, she notices that Caroline is watching. It makes her happy. She slowly lowers the lid of her laptop and says, ‘You can have three.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Three?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a one-time offer.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He nods and sits back, like he’s thinking about it. ‘What’s your name?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It takes her a few seconds. ‘Sarah.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you live locally?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not far away.’ She bites into her bagel and chews. ‘One question left …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d better make it a good one then.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, you better had.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leans towards her again and lowers his voice just a little. ‘Do you ever give your phone number to strange men?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She feels herself start to redden again, but it’s for a different reason this time and she doesn’t mind it. ‘Are you strange?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Definitely,’ he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You give me yours.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reels off a number and she keys it into her phone. She dials, and a few seconds later his phone starts to ring. He glances at the screen, nods, and turns the call off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, strange but honest,’ she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is that good?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s OK,’ she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They fall silent after that, as if they have both decided that enough has been said. She looks across and sees that now, Heather, Savita and Caroline are all watching her. It’s a nice result. She likes the fact that, for once, she’s the one setting the agenda for later on, that she’s giving them something to talk about at pick-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v("Is "), _c('em', [_vm._v("this")]), _vm._v(" a pick-up?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, yes, it certainly feels like one and she’s surprised at how happy she is about that. It’s been a while.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the man stands to leave, he ties a scarf at his neck and says, ‘My name’s Conrad by the way. Oh, and my money’s definitely on something literary.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She watches him leave, then opens her laptop again, knowing she has no need to check that she’s still being observed by the trio of mothers in the window. Her screensaver appears again, and she doesn’t bother trying to hide the grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A dark-haired boy in a Chelsea shirt. Gap-toothed and goofy, thumbs held aloft. Squinting against the sun, with the unbroken blues of sea and cloudless sky behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jamie …")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767d06be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ch05.vue
// module id = 96
// module chunks = 0